import { slugify } from "../../../helpers"
import { ArticlesProps } from "../Part/Part.d"

export const addRoutesToArticles = (
  articles: ArticlesProps[],
  articleRoutes: any[],
  category: string,
  translations: any[],
  language: string,
) => {
  return articles?.map((article: any) => {
    const matchingRoutes = articleRoutes?.filter(route => {
      if (language === "es") {
        const esId = translations?.find(item => item.es?._id === article?._id)
        const routePageId = esId?.en?._id
        return (
          route?.page?._id === routePageId &&
          !route.slug?.current?.includes("partsandservice")
        )
      } else {
        return (
          route.page?._id === article._id &&
          !route.slug?.current?.includes("partsandservice")
        )
      }
    })

    // Select route based on Landing Page category
    let route
    if (category === "all") {
      route = matchingRoutes?.reduce((shortestRoute, currentRoute) => {
        return currentRoute.slug?.current.length <
          shortestRoute.slug?.current.length
          ? currentRoute
          : shortestRoute
      }, matchingRoutes[0])
    } else {
      route = matchingRoutes.find(route =>
        route.slug?.current.includes(`car-care-tips/${slugify(category)}/`),
      )
    }

    return { ...article, route }
  })
}
